import React from "react";
import { useNavigate } from "react-router-dom";
import "./header.css";

export const Header = ({ pageTitle, showLogout = false, onLogout }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/landing");
  };

  return (
    <div className="headerMain">
      <div
        className="headerTitle"
        onClick={handleLogoClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleLogoClick();
          }
        }}
        role="button"
        tabIndex={0}
        title="Go to landing"
      >
        <p className="headerTitleFont">Alpap CRM</p>
      </div>

      <div className="headerPageTitle">
        <p className="pageTitleFont">{pageTitle}</p>
      </div>

      {showLogout && (
        <button className="headerLogoutButton" onClick={onLogout}>
          Logout
        </button>
      )}
    </div>
  );
};